import { restApi } from "@/api/index";

export const getPropertiesConfig = () => {
  return restApi.get("/user/properties/config");
};

export const getUserProperties = () => {
  return restApi.get("/user/properties");
};

export const syncUserProperties = (data) => {
  return restApi.post("/user/properties", data);
};
